/** @module csi/table/matrix/RowRootMap */
define([
	"dojo/_base/declare",
	"./_RootMap"
], function(declare,_RootMap) {

	/**
	 * This matrix allows you to have an editable matrix in a view of aggregate data, where the data is stored in a
	 * map on the root node of the view. The key to the map comes from an attribute of the table's row nodes.
	 *
	 * Reference: https://centric8.atlassian.net/wiki/spaces/AAT/pages/1298825877/Table+Matrix+Configuration#RowRootMap
	 */

	return declare(_RootMap, {
		/** @property {string} mapKeyRowId - attribute id of row class that holds unique id for row */
		mapKeyRowId: "SysID",

		/**
		 * @override
		 * Return index based on row node's attribute value
		 */
		_getSpecIndices: function(ctx, spec, nodes) {
			var row = nodes[0];
			var key = row[this.mapKeyRowId];
			return [key];
		}
	});
});